/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DigitizingMelcoDigitizingModelsDigitizingOutputFormatListItem
 */
export interface DigitizingMelcoDigitizingModelsDigitizingOutputFormatListItem {
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsDigitizingOutputFormatListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsDigitizingOutputFormatListItem
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsDigitizingOutputFormatListItem
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsDigitizingOutputFormatListItem
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DigitizingMelcoDigitizingModelsDigitizingOutputFormatListItem
     */
    sort_order?: number;
}

export function DigitizingMelcoDigitizingModelsDigitizingOutputFormatListItemFromJSON(json: any): DigitizingMelcoDigitizingModelsDigitizingOutputFormatListItem {
    return DigitizingMelcoDigitizingModelsDigitizingOutputFormatListItemFromJSONTyped(json, false);
}

export function DigitizingMelcoDigitizingModelsDigitizingOutputFormatListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingMelcoDigitizingModelsDigitizingOutputFormatListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'sort_order': !exists(json, 'sort_order') ? undefined : json['sort_order'],
    };
}

export function DigitizingMelcoDigitizingModelsDigitizingOutputFormatListItemToJSON(value?: DigitizingMelcoDigitizingModelsDigitizingOutputFormatListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'code': value.code,
        'name': value.name,
        'description': value.description,
        'sort_order': value.sort_order,
    };
}


